import React from "react";
import { IKO, chipStyle } from "@/lib/design";

export function IkoChip({ iko, size = "sm", solid = false, className = "" }) {
  if (!iko || !IKO[iko]) {
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-full border border-dashed px-2.5 py-0.5 text-xs opacity-60 ${className}`}>
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: "currentColor" }} />
        No Iko
      </span>
    );
  }
  const style = chipStyle(iko, { solid });
  const cls = size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs";
  const t = IKO[iko];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${cls} ${className}`}
      style={style}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: t.hex }} />
      {t.label}
    </span>
  );
}
